import { useTLang } from 'intl/intl';

export function useScheduledOrderDetailDialogLang() {
  return {
    loadingLabel: useTLang({ id: 'scheduleOrder.loadingLabel' }),
    cancelOrder: useTLang({ id: 'scheduleOrder.detail.cancelOrder' }),
  };
}
